<template>
   <main>
      <slide />

      <!-- lancamentos day area start -->
      <lancamentos :array="clienteData.lancamentos" :titulo="'Lançamentos'" :classes="'lancamentos__area pt-50 pb-50 grey-bg'" />

      <!-- blog area start -->
      <section class="blog__area pt-40 pb-40" v-show="clienteData.noticias != null && clienteData.noticias.length > 0">
         <div class="container">
            <div class="section__head mb-20">
               <div class="w-100 section__title">
                  <h3 class="text-center mb-1">Notícias</h3>
               </div>
            </div>
            <div class="grid">
               <noticia v-for="(noticia, index) in clienteData.noticias" :key="index" :noticia="noticia" :index="index" :view="'Grid'" />
            </div>
         </div>
      </section>

      <!-- about start -->
      <section class="about__area pt-40 pb-40 grey-bg">
         <div class="container">
            <div class="section__head mb-20">
               <div class="w-100 section__title">
                  <h3 class="text-center mb-1">Sobre nós</h3>
               </div>
            </div>
            <div class="row align-items-center">
               <div class="col-xl-6 px-xxl-5">
                  <div class="w-img pb-5 pb-xxl-0">
                     <img class="rounded" src="@/assets/cliente/img/banner/empresa-01.jpg" />
                  </div>
               </div>
               <div class="col-xl-6 px-xxl-5 text-justify">
                  <p v-html="sourceHome.sobreNos_descricao"></p>
                  <div class="w-100 text-center mt-40">
                     <router-link to="/historia" class="btn btn-outline-primary font-14"><span v-html="sourceHome.sobreNos_botaoVerMais"></span> <i class="fas fa-long-arrow-right font-12 ms-1"></i></router-link>
                  </div>
               </div>
               <div class="col-12 mt-50 d-none d-sm-block">
                  <div class="video__content px-5 ratio ratio-21x9">
                     <iframe :src="sourceHome.sobreNos_videoURL" title="Institucional" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                  </div>
               </div>
               <div class="col-12 mt-50 d-none d-sm-block" v-if="clienteData.depoimentos != null && clienteData.depoimentos.length > 0">
                  <div class="d-flex justify-content-center">
                     <depoimento v-for="(depoimento, index) in clienteData.depoimentos" :key="index" :depoimento="depoimento" />
                  </div>
               </div>
            </div>
         </div>
      </section>

      <!-- revendas start -->
      <section class="revendas__area pt-50 pb-xl-5">
         <div class="revendas__head pb-4 pb-xl-5">
            <div class="section__head">
               <div class="w-100 section__title">
                  <h3 class="text-center mb-1">Revendas</h3>
               </div>
            </div>
         </div>
         <div class="theme-bg">
            <div class="container pt-30 pb-30">
               <div class="row">
                  <div class="col-xl-6 px-xxl-5">
                     <img src="@/assets/cliente/img/banner/empresa-02.jpg" />
                  </div>
                  <div class="col-xl-6 px-xxl-5 text-white align-self-center text-justify">
                     <p class="limitador-10" v-html="sourceHome.sejaRevendedor_descricao"></p>
                     <div class="w-100 d-flex px-md-5 mt-30">
                        <hr class="col">
                        <div class="w-max-content ps-4 pt-1 weight-600 font-16">
                           <a :href="urlCCM +'/sejaRevendedor'" target="_blank">Seja um revendedor <i class="fas fa-plus font-16 ms-2"></i></a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>

      <!-- downloads start -->
      <section class="downloads__area pt-40 pb-20 grey-bg">
         <div class="container">
            <div class="section__head mb-30">
               <div class="w-100 section__title">
                  <h3 class="text-center mb-1">Material de Apoio</h3>
               </div>
            </div>
            <div class="row justify-content-center px-5">
               <div class="col-sm-6 col-lg-3 px-xl-5 mb-50 text-center">
                  <i class="fal fa-newspaper color-theme font-90"></i>
                  <h1 class="mt-4 mb-2 color-theme font-18">Catálogos</h1>
                  <p v-html="sourceHome.downloads_catalogosDescricao"></p>
                  <!-- <router-link to="/downloads" class="btn btn-primary font-13">Acesse</router-link> -->
                  <a href="https://ccmdobrasil.com.br/catalogo/" target="_blank" class="btn btn-primary font-13">Acesse</a>
               </div>
               <div class="col-sm-6 col-lg-3 px-xl-5 mb-50 text-center">
                  <i class="fal fa-book color-theme font-90"></i>
                  <h1 class="mt-4 mb-2 color-theme font-18">Manuais</h1>
                  <p v-html="sourceHome.downloads_manuaisDescricao"></p>
                  <router-link to="/downloads/manuais" class="btn btn-primary font-13">Acesse</router-link>
               </div>
               <div class="col-sm-6 col-lg-3 px-xl-5 mb-50 text-center">
                  <i class="fal fa-file-alt color-theme font-90"></i>
                  <h1 class="mt-4 mb-2 color-theme font-18">Folhetos</h1>
                  <p v-html="sourceHome.downloads_folhetosDescricao"></p>
                  <router-link to="/downloads/folhetos" class="btn btn-primary font-13">Acesse</router-link>
               </div>
               <div class="col-sm-6 col-lg-3 px-xl-5 mb-50 text-center">
                  <i class="fal fa-calculator-alt color-theme font-90"></i>
                  <h1 class="mt-4 mb-2 color-theme font-18">Calculadora inteligente</h1>
                  <p v-html="sourceHome.downloads_calculadoraDescricao"></p>
                  <router-link to="/calculadora" class="btn btn-primary font-13">Acesse</router-link>
               </div>
            </div>
         </div>
      </section>

      <!-- videos start -->
      <section class="videos__area pt-50 pb-50">
         <div class="container pt-30 pb-30">
            <div class="row text-white justify-content-center justify-content-sm-start">
               <div class="w-max-content px-xl-5 d-flex align-items-center">
                  <i class="fal fa-desktop font-170 d-none d-sm-inline"></i>
                  <div class="w-290 ms-sm-5 text-center text-sm-start">
                     <h3>Vídeos</h3>
                     <p class="limitador-4" v-html="sourceHome.videos_descricao"></p>
                     <a :href="contato.youtube" target="_blank" class="btn btn-primary font-14">Acesse</a>
                  </div>
               </div>
               <div class="col d-none d-sm-block"></div>
            </div>
         </div>
      </section>

      <!-- encontre__revenda start -->
      <section class="encontre__revenda__area pt-70 pb-70">
         <div class="container">
            <div class="row justify-content-center px-sm-5">
               <div class="w-max-content color-theme py-md-3">
                  <i class="fal fa-map-marker-alt font-170 d-none d-md-block"></i>
                  <i class="fal fa-map-marker-alt font-70 mb-40 d-block d-md-none"></i>
               </div>
               <div class="col-md ms-md-5 text-center text-md-start">
                  <p class="limitador-8" v-html="sourceHome.encontreRevenda"></p>
                  <div class="w-100 d-flex px-lg-5 mt-30">
                     <hr class="col bg-theme">
                     <div class="w-max-content ps-4 pt-1 weight-600 font-16 color-theme">
                        <router-link to="/encontreRevenda">Encontre uma revenda <i class="fas fa-plus font-16 ms-2"></i></router-link>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>

      <!-- contato start -->
      <section class="contato__area pt-50 pb-60 grey-bg">
         <div class="container">
            <div class="section__head mb-20">
               <div class="w-100 section__title">
                  <h3 class="text-center mb-1">Fale com a gente</h3>
               </div>
            </div>
            <div class="row align-items-center">
               <div class="col-xxl-6 px-xxl-5 text-justify">
                  <div class="row">
                     <div class="col-12 mb-3">
                        <p v-html="sourceHome.faleConosco_descricao"></p>
                     </div>
                     <div class="col-12 mb-2">
                        <label>Nome *</label>
                        <input type="text" class="form-control" v-model="faleConosco.nome" maxlength="200" />
                     </div>
                     <div class="col-6 mb-2">
                        <label>Email *</label>
                        <input type="email" class="form-control" v-model="faleConosco.email" maxlength="200" />
                     </div>
                     <div class="col-6 mb-2">
                        <label>Telefone *</label>
                        <input type="text" class="form-control" v-model="faleConosco.telefone" maxlength="200" />
                     </div>
                     <div class="col-6 mb-2">
                        <label>CPF/CNPJ</label>
                        <input type="email" class="form-control" v-model="faleConosco.cpfCnpj" maxlength="200" />
                     </div>
                     <div class="col-6 mb-2">
                        <label>CEP</label>
                        <div class="input-group">
                           <input type="text" class="form-control" v-model="faleConosco.cep" maxlength="50" @keyup.enter="buscarCEP" />
                           <a href="javascript:;" class="input-group-text font-13" @click="buscarCEP" v-if="faleConosco.cep != ''">
                              <i class="fas fa-search"></i>
                           </a>
                        </div>
                     </div>
                     <div class="col-6 mb-2">
                        <label>Cidade</label>
                        <input type="email" class="form-control" v-model="faleConosco.cidade" maxlength="200" />
                     </div>
                     <div class="col-6 mb-2">
                        <label>Estado</label>
                        <input type="email" class="form-control" v-model="faleConosco.estado" maxlength="200" />
                     </div>
                     <div class="col-12 mb-2">
                        <label>Mensagem *</label>
                        <textarea class="form-control" v-model="faleConosco.mensagem" maxlength="200"></textarea>
                     </div>
                     <div class="col-12 text-end">
                        <button class="t-y-btn t-y-btn-2" @click="enviarFaleConosco">Enviar</button>
                     </div>
                  </div>
               </div>
               <div class="col-xxl-6 d-none d-xxl-block">
                  <div class="w-img">
                     <img class="rounded" src="@/assets/cliente/img/banner/empresa-03.jpg" />
                  </div>
               </div>
            </div>
         </div>
      </section>

      <!-- Promocional -->
      <div class="modal fade" id="modalPromocional" tabindex="-1" role="dialog" aria-hidden="true">
         <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div class="modal-content">
               <div class="modal-body p-0 overflow-hidden">
                  <button class="btn btn-close-modal" data-bs-dismiss="modal" aria-label="Close"><i class="far fa-times"></i></button>
                  <a class="ratio ratio-4x3 d-block" :href="clienteData.redirecionamentoPopup" target="_blank">
                     <img :src="clienteData.imagePopup" />
                  </a>
               </div>
            </div>
         </div> 
      </div>
   </main>
</template>

<script>

import Swal from 'sweetalert2'
import { mapState } from 'vuex'
import slide from '@/components/Slide.vue'
import noticia from '@/components/noticias/Noticia.vue'
import depoimento from '@/components/home/Depoimento.vue'
import lancamentos from '@/components/CarouselProdutos.vue'

export default {
	name: 'Home',
   data : function () {
      return {
         faleConosco: {'nome': '', 'telefone': '', 'email': '', 'mensagem': '', 'cpfCnpj': '', 'cep': '', 'cidade': '', 'estado': ''},
         observer: null
      }
   },
   computed: {
		... mapState({
			clienteData: state => state.clienteData,
         contato: state => state.source.contato,
			sourceHome: state => state.source.home,
         urlRest: state => state.urlRest,
         urlCCM: state => state.urlCCM
		})
	},
   components: {
      lancamentos, noticia, slide, depoimento
   },
   methods: {
      buscarCEP : function () {
         this.$store.dispatch('buscarCEP', this.faleConosco.cep).then((data) => {
            this.faleConosco.cidade = data.localidade
            this.faleConosco.estado = data.uf
			})
      },
      enviarFaleConosco : function () {
         if (this.faleConosco.nome == null || String(this.faleConosco.nome).trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Nome inválido!'
            });

            return
         } else if (this.faleConosco.telefone == null || String(this.faleConosco.telefone).trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Telefone inválido!'
            });

            return
         } else if (this.faleConosco.email == null || String(this.faleConosco.email).trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Email inválido!'
            });

            return
         } else if (this.faleConosco.mensagem == null || String(this.faleConosco.mensagem).trim().length == 0) {
            this.$toast.fire({
               icon: 'error',
               title: 'Mensagem inválida!'
            });

            return
         }

         this.$store.dispatch('alternarTelaCarregamento', 1)

         this.$axios({
            method: 'post',
            url: this.urlRest +'site/faleConosco',
            headers: {
					'Content-Type': 'application/json'
            },
				data: this.faleConosco

         }).then(() => {
            Object.assign(this.$data.faleConosco, this.$options.data.apply(this).faleConosco)

            Swal.fire({
               icon: 'success',
               title: 'Mensagem enviada!'
            });
         }).catch((error) => {
            if (error.response != undefined) {
               this.$toast.fire({
                  icon: 'error',
                  title: 'Erro: ' + error.response.status
               });
            } else {
               this.$toast.fire({
                  icon: 'error',
                  title: error
               });
            }
         }).finally(() => {
            this.$store.dispatch('alternarTelaCarregamento', -1)
         });      
      }
   }
}

</script>